import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function LegalPage({ docType, title }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/legal/${docType}`)
      .then((res) => setData(res.data))
      .catch(() => setData({ content: null }))
      .finally(() => setLoading(false));
  }, [docType]);

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 py-3">
          <Link to="/" className="flex items-center gap-2 w-fit">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <MapPin className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-xl">lokalnie.pro</span>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-6">{title}</h1>

        {loading ? (
          <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>
        ) : (
          <Card>
            <CardContent className="p-6 space-y-4">
              {data?.content ? (
                <>
                  <p className="whitespace-pre-wrap text-sm text-slate-700 leading-relaxed">{data.content}</p>
                  {data.updated_at && (
                    <p className="text-xs text-slate-400 pt-4 border-t">
                      Ostatnia aktualizacja: {new Date(data.updated_at).toLocaleDateString("pl-PL")}
                    </p>
                  )}
                </>
              ) : (
                <p className="text-sm text-slate-500">{title} nie został jeszcze uzupełniony.</p>
              )}

              {docType === "privacy" && data?.dpo_contact_email && (
                <p className="text-sm text-slate-700 pt-4 border-t">
                  W sprawach ochrony danych osobowych (dostęp, sprostowanie, usunięcie danych) napisz na:{" "}
                  <a href={`mailto:${data.dpo_contact_email}`} className="text-emerald-700 hover:underline">
                    {data.dpo_contact_email}
                  </a>
                </p>
              )}
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}
